import {
    ColoursObj,
    Typography,
    getContrastYIQ,
} from '@eventr/common-storybook';
import { Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

export function ItineraryTitle({ id, name }: { id?: string; name: string }) {
    const [useLongVer, setUseLongVer] = useState<boolean>(false)

    const typoRef = useRef(null)

    useEffect(() => {
        try {
            const refObj = typoRef.current as unknown as HTMLDivElement

            if (refObj.clientWidth === (refObj.firstChild as any).clientWidth) {
                if (!useLongVer) {
                    setUseLongVer(true)
                }
            }
        } catch {
            /// error but no need to panic
        }
    }, [typoRef])

    return (
        <Box
            ref={typoRef}
            sx={{
                display: 'grid',
                justifySelf: 'center',
                justifyItems: 'center',
                maxHeight: '44px',
                width: 'calc(100dvw - 86px)',
                overflow: 'hidden',
            }}
        >
            <Typography
                sx={{
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    display: '-webkit-box',
                    alignItems: 'center',
                    textAlign: 'center',
                    width: 'max-content',
                    maxWidth: 'calc(100dvw - 86px)',
                }}
                color={getContrastYIQ(ColoursObj.backgrounds.header)}
                style={{
                    fontSize: useLongVer ? '14px' : '20px',
                    fontWeight: '700',
                    fontFamily: 'Inter-600-900',
                    lineHeight: useLongVer ? '16px' : '32px',
                    zIndex: 100,
                }}
                id={`${id}itineraryName`}
            >
                {name}
            </Typography>
        </Box>
    )
}
